import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export class GetUsersWithPaginationService {
  async run(params: parmsRomms) {
    const response :any= await getByQuery<any[]>(`${services.users}/list-with-pagination`, params);
    return  {data:response.data, ...response.pagination};
  };
};